import { useAuth } from "contexts/authContext";
import * as S from "./styles";

type Props = {
  className?: string;
};

function ScannerPin({ className = "" }: Props) {
  const { config } = useAuth();
  return (
    <S.Container className={className}>
      <svg
        id="es02IFulWmU1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
      >
        <g transform="translate(-250-250)">
          <g id="es02IFulWmU3_ts" transform="translate(300,300) scale(1,1)">
            <ellipse
              id="es02IFulWmU3"
              rx="13.793103"
              ry="13.793103"
              transform="translate(-0.000001,-0.000001)"
              fill={config?.color || "#ff8f01"}
              fillOpacity="0.8"
              strokeWidth="0"
            />
          </g>
          <g id="es02IFulWmU4_ts" transform="translate(300,300) scale(1,1)">
            <ellipse
              id="es02IFulWmU4"
              rx="8"
              ry="8"
              transform="translate(0,0)"
              fill={config?.color || "#ff8f01"}
              fillOpacity="0.8"
              strokeWidth="0"
            />
          </g>
          <ellipse
            rx="8"
            ry="8"
            transform="translate(300 300)"
            fill={config?.color || "#ffbe01"}
            strokeWidth="0"
          />
        </g>
      </svg>
    </S.Container>
  );
}

export { ScannerPin };
